import { render, staticRenderFns } from "./sri.vue?vue&type=template&id=a5e3af42"
import script from "./sri.vue?vue&type=script&lang=js"
export * from "./sri.vue?vue&type=script&lang=js"
import style0 from "./sri.vue?vue&type=style&index=0&id=a5e3af42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports